// paymentTypeHelper ===>

const dictionary = {
  quick: "حمایت از موسسه نیکوکاری",
  support: "حمایت از موسسه نیکوکاری",
  organization: "حمایت از موسسه نیکوکاری",
  immediate: "حمایت از موسسه نیکوکاری",
  cart: "خرید کارت نیکوکاری",
  campaign: "حمایت از کمپین نیکوکاری",
  charge: "شارژ کیف پول اجتماعی",
  project: "حمایت از پروژه نیکوکاری",
  external: "پرداخت از سایر پلتفرم ها",
  continuous: "حمایت مستمر",
  membership_fee: "حق عضویت",
  salon_reserve: "اجاره نماد/سالن",
  cash_back: "بازگشت وجه از پروژه نیکوکاری",
  personal_project: "یادمان",
  settlement: "برداشت از کیف پول موسسه",
  dedicate_page_payment: "حمایت از موسسه نیکوکاری",
  home_page: "کمپین های آگاپه",
  // pwa =>
  pwa_charge: "شارژ کیف پول اجتماعی",
  pwa_support: "حمایت از کمپین نیکوکاری",
  pwa_agape_support: "حمایت از موسسه نیکوکاری",
  pwa_continuous: "حمایت مستمر",
  // dic =>
  accepted: "پذیرفته شده",
  pending: "درحال بررسی",
  rejected: "رد شده",
  // models =>
  "App\\Models\\Organization": "وان پیج سازمان",
  "App\\Models\\OrganizationProgressReport": "مطالب سازمان",
  "App\\Models\\Petition": "تومار",
  "App\\Models\\Project": "پروژه نیکوکاری",
  "App\\Models\\Comment": "نظرات",
  "App\\Models\\OrganizationRealMembership": "حقیقی",
  "App\\Models\\OrganizationLegalMembership": "حقوقی",
  // salon type =>
  meeting: "سالن جلسه",
  condolence: "نماد تسلیت",
  congratulation: "نماد تبریک",
  seminar: "سالن سمینار",
  conference: "سالن کنفرانس",
};

const paymentTypeHelper = (key) => {
  if (typeof key !== "string") {
    console.error(
      'usePaymentTypeHelper: propTypeError => prop type could be "string"'
    );
    return "prop type error";
  }

  if (dictionary[key]) {
    return dictionary[key];
  }

  console.warn(
    `usePaymentTypeHelper: notFound => please update "dictionary" with this new word (${
      key || null
    })`
  );

  return key || null;
};

export default paymentTypeHelper;
